import { I18n, I18nType } from '@schemas'

class AccessControl {
	constructor({
		id = '',
		accessGroupId = '',
		menuId = '',
		crud = '',
		menuName = '',
		menuI18n = [],
		menuIcon = '',
		menuPath = '',
		menuUri = '',
		menuFolderYn = 0,
		menuActivateYn = 0,
		deletedAt = '',
		createdBy = '',
		createdAt = '',
	} = {}) {
		this.id = id === null ? '' : id
		this.accessGroupId = accessGroupId === null ? '' : accessGroupId
		this.menuId = menuId === null ? '' : menuId
		this.crud = crud === null ? '' : crud
		this.menuName = menuName === null ? '' : menuName
		this.menuI18n =
			menuI18n === null
				? []
				: (menuI18n.map(anMenuI18n => new I18n(anMenuI18n)) as I18nType[])
		this.menuIcon = menuIcon === null ? '' : menuIcon
		this.menuPath = menuPath === null ? '' : menuPath
		this.menuUri = menuUri === null ? '' : menuUri
		this.menuFolderYn = menuFolderYn === null ? false : menuFolderYn === 1 ? true : false
		this.menuActivateYn =
			menuActivateYn === null ? false : menuActivateYn === 1 ? true : false
		this.deletedAt = deletedAt === null ? '' : deletedAt
		this.createdBy = createdBy === null ? '' : createdBy
		this.createdAt = createdAt === null ? '' : createdAt
	}
	id: string
	accessGroupId: string
	menuId: string
	crud: string
	menuName: string
	menuI18n: I18nType[]
	menuIcon: string
	menuPath: string
	menuUri: string
	menuFolderYn: boolean
	menuActivateYn: boolean
	deletedAt: string
	createdBy: string
	createdAt: string
}

export { AccessControl }
